<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="快码域">
              <a-select v-model="defaultValue" @change="handleChange">
                <a-select-option v-for="(item) in LOOKUP_LIST" :key="item.key">{{ item.value }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="快码">
              <a-input placeholder="请输入" v-model="queryParams.lookupType"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="快码说明">
              <a-input placeholder="请输入" v-model="queryParams.lookupName"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="状态">
              <a-radio-group button-style="solid" v-model="queryParams.status">
                <a-radio-button
                  v-for="dict in statusOptions"
                  :key="dict.dictValue"
                  :value="dict.dictValue">
                  {{ dict.dictLabel }}
                </a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="$refs.createModal.show()" type="primary" v-hasPermi="['system:lookup:add']" >新增</a-button>
      <a-button @click="handleDeleteBatch(selectedRowKeys)" v-hasPermi="['system:lookup:remove']" :disabled="selectedRowKeys.length === 0">删除</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1300 }"
          @selectedRowChange="selectedRowChange"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.LOOKUP_LIST, // 表格方案配置唯一值
              }"
        >
          <!-- 更多选择 -->
          <span slot="action" slot-scope="{ record }">
            <a @click="$refs.createModal.show(record)" v-hasPermi="['system:lookup:edit']">编辑</a>
            <a href="javascript:;" class="ml10" @click="$refs.attributeModal.show(record)">属性定义</a>
          </span>
          <!-- 插槽指向状态 -->
          <span slot="status" slot-scope="{ record }">
            {{ statusFormat(record) }}
          </span>
          <!-- 插槽指向状态 -->
          <span slot="lookupType" slot-scope="{ record }">
            <a @click="handleDetail(record)">{{ record.lookupType }}</a>
          </span>
          <template slot="createTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
        </ls-api-table>
        <!-- 创建/编辑快码,单独封装了组件 -->
        <look-up-add-edit
          ref="createModal"
          :parentId="defaultValue"
          :lookupList="LOOKUP_LIST"
          @handle-success="handleOk"
        />
        <look-up-attribute
          ref="attributeModal"
          @handle-success="handleOk"
        />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { apiLookupTypeDelete, apiLookupTypeList } from '@/api/system/lookup/type'
import LookUpAddEdit from './components/look-up-add-edit'
import LookUpAttribute from './components/look-up-attribute'
import { generateLsTableResData } from '@/utils/util.js';

export default {
  name: 'Lookup',
  components: {
    LookUpAddEdit,
    LookUpAttribute
  },
  data () {
    return {
      // 表格配置
     tableProps: {
        requestApi: generateLsTableResData(apiLookupTypeList, true),
        pageCurrent: true
      },
      pageParams: {
        automatic: false,
        pageUrl: '/system/lookup/type/list',
        tableLoading: false
      },
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        parentId: undefined,
        lookupName: undefined,
        lookupType: undefined,
        status: undefined
      },
      // 状态快码
      statusOptions: [
        {
          dictLabel: "正常",
          dictValue: "0"
        },
        {
          dictLabel: "停用",
          dictValue: "1"
        }
      ],
      // 快码表格数据
      typeList: [],
      // 表格字段
      columns: [
        {
          title: '快码',
          dataIndex: 'lookupType',
          ellipsis: true,
          scopedSlots: { customRender: 'lookupType' },
          align: 'center'
        },
        {
          title: '快码说明',
          dataIndex: 'lookupName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          ellipsis: true,
          scopedSlots: { customRender: 'status' },
          align: 'center'
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: '操作',
          width: 140,
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {},
        onSelectAll: (selected, selectedRows, changeRows) => {}
      },
      LOOKUP_LIST: [], // 快码域
      defaultValue: ""
    }
  },
  created () {},
  mounted () {
    const parentId = sessionStorage.getItem("parentId") || null;
    this.getLookupList(parentId)
  },
  destroyed () {
    sessionStorage.removeItem("parentId")
  },
  methods: {
    // 跳转快码详情
    handleDetail (record) {
      this.$router.push({ name: `look-up-detail`, query: { id: record.id, lookupType: record.lookupType, parentId: this.defaultValue } })
    },
    /** 行选中 */
    selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    // 表单搜索
    onSearch () {
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
    },
    getLookupList (val) {
      const params = {
        pageNum: 1,
        pageSize: 100,
        parentId: 0
      }
      apiLookupTypeList(params).then(res => {
        if (res.code === 200 && res.rows && res.rows.length > 0) {
          const arr = res.rows;
          const list = [];
          arr.forEach(element => {
            const obj = {
              key: element.id,
              value: element.lookupName
            }
            list.push(obj)
          });
          this.LOOKUP_LIST = list; // 快码域
          this.queryParams.parentId = !val ? list[0].key : Number(val)
          this.defaultValue = !val ? list[0].key : Number(val)
         // this.$refs.page.getFirstPage(this.queryParams)
         this.onSearch()
        }
      })
    },
    // 快码域
    handleChange (value) {
      this.queryParams.parentId = value;
      this.handleQuery()
    },
    /** 查询快码类型列表 */
    getList (data) {
      this.typeList = data
    },
    // 新增/修改框事件
    handleOk () {
      // this.$refs.page.getFirstPage(this.queryParams)
      this.onSearch();
    },
    // 快码状态快码翻译
    statusFormat (row, column) {
      return this.selectDictLabel(this.statusOptions, row.status)
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.onSearch();
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        lookupName: undefined,
        lookupType: undefined,
        status: undefined,
        parentId: undefined
      }
      // this.defaultValue = '';
      this.queryParams.parentId = this.defaultValue;
      this.handleQuery()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 批量删除按钮操作 */
    handleDeleteBatch (ids) {
      const self = this
      this.$confirm({
        title: '警告',
        content: `真的要删除 快码编号为${ids}的数据项吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          apiLookupTypeDelete(ids).then(response => {
            if (response.code === 200) {
              self.$message.success('删除成功!')
              self.onSearch();
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="less">

</style>
